import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28824e23"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "viewable grid"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "col-12 text-right text-small"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  id: "text-error",
  class: "p-error"
}
const _hoisted_6 = { class: "dialog-footer grid mt-3" }
const _hoisted_7 = { class: "col-6 flex justify-content-center p-0" }
const _hoisted_8 = { class: "col-6 flex justify-content-center p-0" }

import { ref, withDefaults, onBeforeMount, watch, computed } from "vue";
import { get, set } from "@vueuse/core";
import { REQUIRED_MEMO_MESSAGE, MAX_CHARACTERS_MEMO_MESSAGE } from "@/common/constants/validate-message.constants";
import { MAX_CHARACTERS_MEMO } from "@/common/constants/variable.constants";
import { useConfirm } from "primevue/useconfirm";
import { CONFIRM_DELETE_MEMO_BOOKING_MESSAGE } from "@/common/constants/message.constants";

type IEditableTexarea = {
  customerId: number;
  comment: string;
  onClick: (customerId: number, comment: string) => undefined;
  disabled: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    customerId: null,
    comment: { default: "" },
    onClick: null,
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { customerId: number, comment: string, onClick: (customerId: number, comment: string) => undefined, disabled: boolean };


const visible = ref<boolean>(false);
const confirm = useConfirm();
const commentVal = ref<string>("");
const newCommentValue = ref<string>("");
const errorMessage = ref<string>("");
const initAttributes = () => {
  if (!commentVal.value) {
    commentVal.value = props.comment;
  }
};

const validateNote = () => {
  errorMessage.value = "";
  if (newCommentValue.value.trim() == "") {
    errorMessage.value = REQUIRED_MEMO_MESSAGE;
    return;
  }
  if (newCommentValue.value.length > MAX_CHARACTERS_MEMO) {
    errorMessage.value = MAX_CHARACTERS_MEMO_MESSAGE;
    return;
  }
};

const commentValue = computed(() => get(commentVal).replace(/\n/g, "<br>"));
const onShowDialog = async () => {
  set(newCommentValue, get(commentVal));
  set(visible, true);
};

const onClosedDialog = () => {
  set(newCommentValue, "");
  set(errorMessage, "");
  set(visible, false);
};

const onTrash = () => {
  confirm.require({
    defaultFocus: "",
    message: CONFIRM_DELETE_MEMO_BOOKING_MESSAGE,
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    acceptClass: "p-button",
    accept: async () => {
      const { customerId } = props;
      props.onClick(customerId, newCommentValue.value);
      set(commentVal, "");
    },
  });
};
const editableOff = () => {
  validateNote();
  if (errorMessage.value === "") {
    const { customerId } = props;
    if (props.onClick && newCommentValue.value != props.comment) {
      props.onClick(customerId, newCommentValue.value);
    }
    set(commentVal, get(newCommentValue));
    set(visible, false);
  }
};
onBeforeMount(() => {
  initAttributes();
});

// Watch for changes in props.comment and update commentVal
watch(
  () => props.comment,
  newValue => {
    commentVal.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (commentVal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "col-12 note-value max-w-full",
            innerHTML: _unref(commentValue)
          }, null, 8, _hoisted_2),
          (!props.disabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("i", {
                  class: "pi pi-pencil cursor-pointer mr-2",
                  onClick: onShowDialog
                }),
                _createElementVNode("i", {
                  class: "pi pi-trash cursor-pointer",
                  onClick: onTrash
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (!props.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("i", {
              class: "pi pi-pencil icon-pi-pencil-orange cursor-pointer mr-2",
              onClick: onShowDialog
            })
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: '予約メモを追加',
      class: "mx-5 dialog-note border-0",
      draggable: false,
      onHide: onClosedDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Textarea, {
          modelValue: newCommentValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newCommentValue).value = $event)),
          "aria-describedby": "description-help",
          type: "text",
          size: "large",
          name: "note",
          rows: "10",
          cols: "30",
          class: _normalizeClass(["textarea-note", { 'p-invalid': errorMessage.value }]),
          placeholder: "予約の情報を追加できます。"
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("small", _hoisted_5, _toDisplayString(errorMessage.value || " "), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Button, {
              label: "キャンセル",
              class: "p-button-light w-100",
              onClick: onClosedDialog
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              class: "w-100",
              label: "保存",
              onClick: editableOff
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})